export const NUMBER_OF_VOLUMES = 5;
export const FORM_NAME = 'discount-groups-form';
